import PaymentProcess from "../../modules/vfs/container/invoiceDetails/PaymentProcess.tsx";
import TravelTakafulCoverNote from "../../modules/vfs/container/invoiceDetails/TravelTakafulCoverNote.tsx";
import React, { lazy } from "react";

const Vfs = lazy(() => import("../../modules/vfs/container/home"));
const VfsPlans = lazy(() => import("../../modules/vfs/container/planListing"));

const VfsPlansDetail = lazy(() => import("../../modules/vfs/container/planDetails"));
const TravelPlansCompare = lazy(() => import("../../modules/travel/container/compare"));

const TravelOrderDetailsDocumentUpload = lazy(() => import("../../modules/travel/container/orderDetails/document-upload"));
const TravelOrderDetailsPaymentDetails = lazy(() => import("../../modules/travel/container/orderDetails/payment-details"));
// const VfsOrderDetailsPersonalDetails = lazy(() => import("../../modules/vfs/container/orderDetails/personal-details"));
const VfsOrderDetailsPersonalDetails = lazy(() => import("../../modules/vfs/container/orderDetails/personal-details/pp.tsx"));
const VfsOrderDetailsReviewDetails = lazy(() => import("../../modules/vfs/container/orderDetails/review-details"));

export const vfsRoutes = [
  {
    path: "/gerrys",
    element: <Vfs />
  },
  {
    path: "/gerrys/plans/:quotationID",
    element: <VfsPlans />
  },
  {
    path: "/gerrys/plans/:quotationID/detail/:id",
    element: <VfsPlansDetail />
  },
  {
    path: "/gerrys/plans/:quotationID/compare/:id",
    element: <TravelPlansCompare />
  },
  {
    path: "/gerrys/order-details/:quotationID/:cartID/document-upload",
    element: <TravelOrderDetailsDocumentUpload />
  },
  {
    path: "/gerrys/order-details/:quotationID/:cartID/payment-details",
    element: <TravelOrderDetailsPaymentDetails />
  },
  {
    path: "/gerrys/order-details/:quotationID/:cartID/personal-details",
    element: <VfsOrderDetailsPersonalDetails />
  },
  {
    path: "/gerrys/order-details/:quotationID/:cartID/review-details",
    element: <VfsOrderDetailsReviewDetails />
  },
  {
    path: "/TravelTakafulCoverNote",
    element: <TravelTakafulCoverNote />
  },
  {
    path: "/paymentInProcess",
    element: <PaymentProcess />
  }
];
